<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="600px"
    style="min-width: 300px"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1" v-if="!modalloading">
        <span class="pt-2 pb-1" style="font-size: 21px">
          <strong>{{ getTitle }}</strong>
        </span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <el-simple-table :items="tableItems" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <el-button
          color="secondary"
          @click.native="cancel()"
          :loading="loading"
          title="Atgal"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import StatementStatus from '@/components/constants/statementStatus'

export default {
  name: 'ModalOrderView',

  props: {
    value: Boolean,
    id: [String, Number],
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      modalloading: false,
      formData: {},
      loading: false,
    }
  },
  computed: {
    showFiz() {
      return this.formData.person_type === 'FIZ'
    },
    showJur() {
      return this.formData.person_type === 'JUR'
    },
    getTitle() {
      let number = this.formData.number || ''
      return `${this.$t(`Išrašas`)}: ${number}`
    },
    tableItems() {
      let items = [
        {
          title: 'Užsakymo pateikimo data ir laikas',
          value: this.formData.receive_date || '',
        },
        {
          title: 'Būsena',
          value: this.formData.status || '',
          enumName: 'StatementStatus',
        },
        {
          title: 'Būsenos data ir laikas',
          value: this.formData.status_date || '',
        },
        {
          title: 'Duomenų apimtis',
          value: this.formData.type || '',
          enumName: 'dataVolumeOrderSav',
        },
        {
          title: 'Vardas',
          value: this.formData.name || '',
          hide: !this.showFiz,
        },
        {
          title: 'Pavardė',
          value: this.formData.lastname || '',
          hide: !this.showFiz,
        },
        {
          title: 'Asmens kodas',
          value: this.formData.criteria_array.fiz_code || '',
          hide: !this.showFiz,
        },
        {
          title: 'ILTU kodas',
          value: this.formData.code || this.formData.criteria_array.iltu_code || '',
          hide: this.formData.person_search_type != 'iltu' || !this.showFiz,
        },
        {
          title: 'Gimimo data',
          value: this.formData.birth_date || '',
          hide: !this.formData.birth_date || !this.showFiz,
        },
        {
          title: 'Juridinio asmens kodas',
          value: this.formData.code || '',
          hide: !this.showJur,
        },
        {
          title: 'Valstybė',
          value: this.formData.country_code || '',
          hide: !this.formData.country_code || !this.showJur,
        },
        {
          title: 'Identifikavimo kodas',
          value: this.formData.mandate_code || '',
          hide: !this.formData.mandate_code,
        },
        {
          title: 'Įgaliojimo notarinio registro Nr.',
          value: this.formData.notarial_code || '',
        },
        {
          title: 'Išrašo dokumento kalba',
          value: this.formData.language || '',
          enumName: 'docLanguage',
        },
        {
          title: 'Duomenų naudojimo tikslas',
          value: this.formData.purpose || '',
          file: this.formData.purpose_file,
        },
        {
          title: 'Teisinis pagrindas',
          value: this.formData.legal_basis || '',
          file: this.formData.legal_basis_file,
        },
        {
          title: 'Atsiėmimo būdas',
          value: this.formData.withdrawal_method || '',
          enumName: 'withdrawalOrder',
        },
        {
          title: 'Atmetimo priežastis',
          value: this.$i18n.locale === 'lt' ? (this.formData.reject_reason || '') : (this.formData.reject_reason_en || ''),
          hide: this.formData.status != StatementStatus.ATMESTAS,
        },
      ]
      return items
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    this.getData()
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    cancel() {
      this.closeModal()
    },
    getData() {
      this.modalloading = true
      this.$axios
        .get(`statement-orders/${this.id}`)
        .then((res) => {
          this.formData = res.data.statementOrder
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.modalloading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
